import { Button } from 'components/Button'
import { useCopyToClipboard } from 'react-use'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

interface Props {
  prompt?: string
}

export const CopyPromptButton = ({ prompt }: Props) => {
  const [, copyToClipboard] = useCopyToClipboard()

  const handlePress = () => {
    if (!prompt) return

    copyToClipboard(prompt)
    showToastMessage('Prompt copied', 'success')
  }

  return (
    <Button size="lg" variant="tertiary" onPress={handlePress} isDisabled={!prompt}>
      Copy Prompt
    </Button>
  )
}
